import { type BasicConfig, fromBasicConfig } from "@hopper-b2b/portal";
import { ClientName } from "@hopper-b2b/types";
import { carsStyleOverrides } from "@hsbc/cars";
import { flightStylesOverrides } from "@hsbc/flights";
import { hotelStyleOverrides } from "@hsbc/hotels";
import {
  portalStyleOverrides,
  themeVariables,
  icons,
  images,
} from "@hsbc/portal";
import { v4 as uuidv4 } from "uuid";
import { branding } from "./branding";
import translations from "./translations";

const hsbcPortalConfig: BasicConfig = {
  clientName: ClientName.HSBC_QA,
  // Environments and Datadog configuration
  bootConfig: {},
  theme: {
    variables: themeVariables,
    styleOverrides: {
      ...flightStylesOverrides,
      ...hotelStyleOverrides,
      ...carsStyleOverrides,
      ...portalStyleOverrides,
    },
    icons,
    images,
  },
  branding,
  translations,
};

export const environmentConfig = {
  env: import.meta.env.MODE,
  viteEnv: import.meta.env.VITE_ENV,
  spreedlyKey: import.meta.env.VITE_SPREEDLY_ENVIRONMENT_KEY ?? "",
  adyenKey: import.meta.env.VITE_ADYEN_ENVIRONMENT_KEY ?? "",
  version: import.meta.env.VITE_REACT_APP_VERSION ?? `local-${uuidv4()}`,
  keepaliveUri: import.meta.env.VITE_KEEPALIVE_URI,
  keepaliveTimeout: import.meta.env.VITE_KEEPALIVE_TIMEOUT ?? 300000,
  preAuthMaintenanceEnabled: import.meta.env.VITE_ENABLE_PRE_AUTH_MAINTENANCE,
  preAuthMaintenanceTitle: import.meta.env.VITE_PRE_AUTH_MAINTENANCE_TITLE,
  preAuthMaintenanceSubtitle: import.meta.env
    .VITE_PRE_AUTH_MAINTENANCE_SUBTITLE,
  timedMaintenanceModeEnabled: import.meta.env
    .VITE_TIMED_MAINTENANCE_MODE_ENABLED,
  timedMaintenanceModeStartTime: import.meta.env
    .VITE_TIMED_MAINTENANCE_MODE_START_TIME,
  timedMaintenanceModeEndTime: import.meta.env
    .VITE_APP_TIMED_MAINTENANCE_MODE_END_TIME,
};

export default fromBasicConfig(hsbcPortalConfig);
